<small
  class="p-error"
  *ngIf="
    formGroup?.get(controlName)?.invalid &&
    (formGroup?.get(controlName)?.touched || formGroup?.get(controlName)?.dirty) &&
    formGroup?.get(controlName)?.errors?.['required'] &&
    !formGroup?.get(controlName)?.errors?.['passwordMismatch']
  ">
  {{ "passwordMessages.enterPasswordError" | translate }}
</small>
<small
  class="p-error"
  *ngIf="
    (formGroup?.get(controlName)?.touched || formGroup?.get(controlName)?.dirty) &&
    formGroup?.get(controlName)?.errors?.['pattern']
  ">
  {{ "passwordMessages.passwordFormatError" | translate }}
</small>
